import { render, staticRenderFns } from "./AddressProof.vue?vue&type=template&id=a333da78&scoped=true&"
import script from "./AddressProof.vue?vue&type=script&lang=ts&"
export * from "./AddressProof.vue?vue&type=script&lang=ts&"
import style0 from "./AddressProof.vue?vue&type=style&index=0&id=a333da78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a333da78",
  null
  
)

export default component.exports